import { IClassname } from '@/lib/shared/model/classname';

export const Bedcloths = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0286 5.77734H30.6961"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4726 5.13815C20.4726 4.29084 20.8092 3.47823 21.4083 2.87909C22.0075 2.27995 22.8201 1.94336 23.6674 1.94336H9.61032C8.76301 1.94336 7.9504 2.27995 7.35126 2.87909C6.75212 3.47823 6.41553 4.29084 6.41553 5.13815V29.4186C6.41553 29.588 6.48285 29.7506 6.60267 29.8704C6.7225 29.9902 6.88502 30.0575 7.05449 30.0575H19.8337C20.0031 30.0575 20.1656 29.9902 20.2855 29.8704C20.4053 29.7506 20.4726 29.588 20.4726 29.4186V5.13815Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.6675 1.94336C24.4999 1.98928 25.2861 2.34062 25.8755 2.93009C26.465 3.51957 26.8164 4.30577 26.8623 5.13815V5.77711"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.8623 10.8887V19.1951C26.8623 19.279 26.8458 19.3621 26.8137 19.4396C26.7816 19.5172 26.7345 19.5876 26.6752 19.6469C26.6158 19.7063 26.5454 19.7533 26.4679 19.7854C26.3904 19.8176 26.3073 19.8341 26.2234 19.8341H23.0286"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.41553 22.3896H20.4726V26.2234H6.41553V22.3896Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.30396 5.77734H6.41562"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.41562 8.33301H1.30396"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6961 8.33301H23.0286"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
